module.exports = __webpack_public_path__ + "static/bg-texture-b7e036b15d1786047317b2ee5651df6b.jpg";